import ATilesSearchResults from './a-tiles-no-searchresults';

export default ATilesSearchResults;